import { Command } from '@/app/common/base/command'

export class ViewMyUploadedDocumentCommand extends Command {
    public async run(id: string): Promise<Blob> {
        const response = await this.client.download(`/api/my-uploaded-documents/${id}/view`, {
            responseType: 'blob',
            timeout: 30000
        })

        return response.data
    }
}

